import { render, staticRenderFns } from "./CardUser.vue?vue&type=template&id=d4de8c16&"
import script from "./CardUser.vue?vue&type=script&lang=ts&"
export * from "./CardUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports